// ** React Imports
import { ChangeEvent } from 'react'

// ** MUI Imports
import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'
import TextField from '@mui/material/TextField'
import IconButton from '@mui/material/IconButton'
import { GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid'

// ** Icons Imports
import Close from 'mdi-material-ui/Close'
import Magnify from 'mdi-material-ui/Magnify'
import { Button, Typography } from '@mui/material'

interface Props {
  value: string
  clearSearch: () => void
  onChange: (e: ChangeEvent) => void
}

const StyledGridToolbarContainer = styled(GridToolbarContainer)({
  p: 2,
  pb: 0,
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'flex-start',
  justifyContent: 'space-between'
})

const TimesaverToolbar = (props: Props) => {
  return (
    <StyledGridToolbarContainer>
      <Box sx={{display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%"}}>
      <Typography variant="h5" >Reuse a previously scheduled batch</Typography>
      <TextField
        variant='outlined'
        value={props.value}
        size="small"
        onChange={props.onChange}
        placeholder='Search campaigns...'
        InputProps={{
          startAdornment: <Magnify fontSize='small' />,
          endAdornment: (
            <IconButton size='small' title='Clear' aria-label='Clear' onClick={props.clearSearch}>
              <Close fontSize='small' />
            </IconButton>
          )
        }}
        style={{marginRight: 20}}
        sx={{
          width: {
            xs: 1,
            sm: 'auto',
          },
          m: theme => theme.spacing(1, 0.5, 1.5),
          '& .MuiSvgIcon-root': {
            mr: 0.5
          },
          '& .MuiInput-underline:before': {
            borderBottom: 1,
            borderColor: 'divider'
          },
        }}
      />
      </Box>
    </StyledGridToolbarContainer>
  )
}

export default TimesaverToolbar;
